import DownloadButton from '@/components/Elements/Button/DownloadButton'
import ViewFileButton from '@/components/Elements/Button/ViewFileButton'
import { Flex } from '@chakra-ui/react'
import moment from 'moment'
import { TooltipCell, NormalTextCellRenderer } from '@/components/Table/components/Cell/ToolTipCell'
import { isNullish } from '@/utils/helper'
import { formatCurrencyAmount } from '@/utils/stringHelper'

const PriceCell = ({ getValue, currency = '' }) => {
  const price = getValue()

  if (isNullish(price) || price === '') {
    return <>(-)</>
  }

  return <TooltipCell text={formatCurrencyAmount(price, currency)} />
}

export default PriceCell
